// extracted by mini-css-extract-plugin
export var cartContainer = "_mw-4";
export var gray = "_mw-1";
export var itemContainer = "_mw-2";
export var itemDetails = "_mw-3";
export var strong = "_mw-0";